import { AbstractControl } from "@angular/forms";

export function estonianPersonalNumberValidator(control: AbstractControl): { format?: boolean } | null {
	const value = String(control.value);
	const regex = /[1-6][0-9]{2}([0][1-9]|[1][0-2])([0][1-9]|[1-2][0-9]|[3][0,1])[0-9]{4}$/;

	if (value.match(regex)) {
		const multipliers = [
			[1, 2, 3, 4, 5, 6, 7, 8, 9, 1],
			[3, 4, 5, 6, 7, 8, 9, 1, 2, 3],
		];

		let mod = getModulus(value, multipliers[0]);

		if (mod === 10) {
			mod = getModulus(value, multipliers[1]);

			if (mod === 10) {
				mod = 0;
			}
		}

		if (mod === Number(value.charAt(value.length - 1))) {
			return null;
		}
	}

	return { format: false };
}

function getModulus(value: string, multipliers: number[]) {
	const total = multipliers
		.map((multiplier, index) => Number(value.charAt(index)) * multiplier)
		.reduce((acc, val) => acc + val);
	return total % 11;
}
